/* Nordic Performance theme JS */
/* Kopierad från Kopia Nordic Performance assets/theme.js (döpt till np-theme.js) */
(function () {
  function initBuybox(root) {
    var opts = root.querySelectorAll('.qb-opt');
    var idInput = root.querySelector('[data-variant-input]');
    var atcPrice = root.querySelectorAll('[data-atc-price]');
    function select(o) {
      opts.forEach(function (x) { x.classList.remove('sel'); });
      o.classList.add('sel');
      var price = o.getAttribute('data-price');
      var vid = o.getAttribute('data-variant-id');
      if (idInput && vid) { idInput.value = vid; }
      atcPrice.forEach(function (el) { if (price) { el.textContent = price; } });
      // sticky subtitle
      var sub = document.querySelector('[data-sticky-sub]');
      if (sub) {
        var label = o.getAttribute('data-label') || '';
        sub.textContent = label + (price ? ' · ' + price : '');
      }
    }
    opts.forEach(function (o) {
      o.addEventListener('click', function (e) {
        // allow inner radio without double toggles
        select(o);
      });
    });
  }

  function initSticky() {
    var hero = document.querySelector('[data-hero]');
    var sticky = document.querySelector('[data-sticky]');
    if (!hero || !sticky) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('on', !entries[0].isIntersecting);
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(hero);
    }
  }

  function initNav() {
    var burger = document.querySelector('[data-burger]');
    var menu = document.querySelector('[data-menu]');
    if (burger && menu) {
      burger.addEventListener('click', function () { menu.classList.toggle('open'); });
    }
  }

  function initFlip() {
    var cards = document.querySelectorAll('.flip-card');
    if (!cards.length) return;
    var isTouch = window.matchMedia('(hover: none)').matches;
    cards.forEach(function (card) {
      // On touch devices, tap toggles. On hover devices, CSS :hover handles it.
      card.addEventListener('click', function (e) {
        // don't hijack clicks on links inside the card
        if (e.target.closest('a')) return;
        if (isTouch) {
          e.preventDefault();
          card.classList.toggle('is-flipped');
        }
      });
      // keyboard accessibility
      card.setAttribute('tabindex', '0');
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.classList.toggle('is-flipped');
        }
      });
    });
  }

  function initDispatch() {
    var el = document.querySelector('[data-dispatch]');
    if (!el) return;
    var msg = el.querySelector('[data-dispatch-msg]');
    if (!msg) return;
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    if (isNaN(cutoff)) cutoff = 16;
    var pre = el.getAttribute('data-pre') || '';
    var post = el.getAttribute('data-post') || '';
    var after = el.getAttribute('data-after') || '';

    function render() {
      var now = new Date();
      var day = now.getDay(); // 0 = Sun, 6 = Sat
      var isWeekend = (day === 0 || day === 6);
      var cut = new Date(now);
      cut.setHours(cutoff, 0, 0, 0);

      if (!isWeekend && now < cut) {
        var diff = Math.floor((cut - now) / 1000);
        var h = Math.floor(diff / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var t = (h > 0 ? h + ' tim ' : '') + m + ' min';
        msg.innerHTML = pre + ' <b>' + t + '</b> ' + post;
      } else {
        msg.textContent = after;
      }
    }
    render();
    setInterval(render, 30000);
  }


  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = document.querySelectorAll('.np-section');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('np-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    els.forEach(function (el, i) { if (i === 0) return; el.classList.add('np-reveal'); io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('np-in'); }); }, 1800);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-buybox]').forEach(initBuybox);
    initSticky();
    initNav();
    initFlip();
    initDispatch();
    initReveal();
  });
})();
